import type { BannerCampaign, BannerContext } from './types';

const inWindow = (c: BannerCampaign, now: number) =>
  (!c.from || now >= Date.parse(c.from)) &&
  (!c.until || now < Date.parse(c.until));

const inRegion = (c: BannerCampaign, region: string) =>
  (!c.regions || c.regions.includes(region)) &&
  !(c.exceptRegions ?? []).includes(region);

export const matches = (c: BannerCampaign, ctx: BannerContext) =>
  inWindow(c, ctx.now) && inRegion(c, ctx.region) && (c.when?.(ctx) ?? true);

/** Ordered campaigns for this context; [] means render nothing. */
export function resolveBanners(
  ctx: BannerContext,
  campaigns: readonly BannerCampaign[],
  suppressed: readonly ((ctx: BannerContext) => boolean)[],
): BannerCampaign[] {
  if (suppressed.some((fn) => fn(ctx))) return [];
  return campaigns
    .filter((c) => matches(c, ctx))
    .sort((a, b) => a.priority - b.priority);
}
